import { render, staticRenderFns } from "./MailingsListDetails.vue?vue&type=template&id=173424f4&scoped=true&"
import script from "./MailingsListDetails.vue?vue&type=script&lang=ts&"
export * from "./MailingsListDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173424f4",
  null
  
)

export default component.exports